<div class="container-fluid">
  <div class="container-fluid container-shadow mt-3 py-5 mb-5">
    <div *ngIf="loading" class="text-center"><i class="fas fa-spinner fa-pulse fa-fw fa-5x"></i></div>
    <div *ngIf="!loading">
      <h3 class="mb-3">
        Taxes - <app-badge badgeType="primary">{{ count }}</app-badge>
      </h3>
      <div class="pb-3">
        <button type="button" [disabled]="loading" (click)="loadTaxes()" class="btn btn-outline-primary">
          <i class="fas fa-sync" [ngClass]="{ 'fa-spin': loading }"></i>
        </button>
        &nbsp;
        <button type="button" (click)="openNewTax()" class="btn btn-outline-primary">
          <i class="fas fa-plus"></i>
          New Tax
        </button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Type</th>
            <th>Account</th>
            <th>Pay To</th>
            <th>Fed/State</th>
            <th>Auto Pay</th>
            <th>Direct Withdrawal</th>
            <th>Factor</th>
            <th>Before Health</th>
            <th>Cutoff</th>
            <th>Frequency</th>
            <th>Amount</th>
            <th>User Field</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tax of taxes">
            <td>
              <a [routerLink]="'/taxes/' + tax.id + '/edit'"><i class="fas fa-pencil-alt"></i></a>
              <a [routerLink]="'/taxes/' + tax.id">{{ tax.id }}</a>
            </td>
            <td>{{ tax.type_str }}</td>
            <td>
              <a [href]="tax.chart_of_account_ledgers_url">{{ tax.chart_of_account_name }}</a>
            </td>
            <td>
              <a [href]="'/contacts/' + tax.contact_id">{{ tax.contact_name }}</a>
            </td>
            <td>{{ tax.is_federal ? 'Fed' : 'State' }}</td>
            <td>{{ tax.is_auto_pay ? 'Yes' : 'No' }}</td>
            <td>{{ tax.is_direct_withdrawal ? 'Yes' : 'No' }}</td>
            <td>{{ tax.is_factor ? 'Yes' : 'No' }}</td>
            <td>{{ tax.is_before_health_deduction ? 'Yes' : 'No' }}</td>
            <td>{{ tax.cutoff || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
            <td>{{ tax.frequency }}</td>
            <td>
              <span *ngIf="tax.way == 'percent'">{{ tax.amount }}{{ tax.amount ? '%' : '' }}</span>
              <span *ngIf="tax.way == 'amount'">{{ tax.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
              <span *ngIf="tax.way != 'percent' && tax.way != 'amount'">variable</span>
            </td>
            <td>{{ tax.user_field }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
